/**
 * Config API Client
 *
 * API functions for managing portal configuration such as
 * notification recipients.
 */

import axiosInstance from "./axiosClient";

export interface NotificationRecipientsResponse {
	application_recipients: string[];
	kyb_recipients: string[];
	admin_users: { email: string; name: string }[];
}

/** Fetch current notification recipients and admin user suggestions. */
export async function getNotificationRecipients(): Promise<NotificationRecipientsResponse> {
	return axiosInstance.get("/api/config/notification-recipients");
}

/** Update notification recipients for applications and KYB. */
export async function updateNotificationRecipients(data: {
	application_recipients: string[];
	kyb_recipients: string[];
}): Promise<void> {
	await axiosInstance.put("/api/config/notification-recipients", data);
}
